import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Swal from "sweetalert2";

import CreatableSelect from "react-select/creatable";
import franchiseAdminAPI from "../../../api/franchiseAdminAPI";
import usersApi from "../../../api/userApi";

const ReassignCustomerModal = ({
  show,
  handleClose,
  selectedCustomer,
  currentReferralCode,
  refreshCustomers,
}) => {
  const [franchiseType, setFranchiseType] = useState("");
  const [franchiseOptions, setFranchiseOptions] = useState([]);
  const [selectedFranchise, setSelectedFranchise] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show) {
      setFranchiseType("");
      setFranchiseOptions([]);
      setSelectedFranchise(null);
    }
  }, [show]);

  useEffect(() => {
    fetchFranchises();
  }, [franchiseType]);

  const fetchFranchises = async () => {
    try {
      if (!franchiseType) return;

      let response;

      if (franchiseType === "FA1") {
        response = await franchiseAdminAPI.getFranchises1List();
      } else {
        response = await franchiseAdminAPI.getFranchises2List();
      }

      const filteredData = response?.data?.filter(
        (item) => item.referralCode !== currentReferralCode,
      );

      const options = filteredData.map((item) => ({
        label: `${item.organization} - ${item.location}`,
        value: item.referralCode,
        data: item,
      }));

      setFranchiseOptions(options);
    } catch (error) {
      console.error("Error fetching franchises:", error);
    }
  };

  const handleSave = async () => {
    if (!selectedFranchise) {
      Swal.fire({
        icon: "warning",
        title: "Please select a franchise",
      });
      return;
    }

    try {
      setLoading(true);

      await usersApi.updateReferralCode(
        selectedCustomer.userId,
        selectedFranchise.value,
      );

      Swal.fire({
        icon: "success",
        title: "Customer moved successfully",
        timer: 2000,
        showConfirmButton: false,
      });

      handleClose();

      if (refreshCustomers) {
        refreshCustomers();
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Failed to move customer",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Reassign Customer</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          Do you want to move this customer to Franchise 1 or Franchise 2?
        </p>

        <div className="d-flex gap-4 mb-3">
          <Form.Check
            type="radio"
            label="Franchise 1"
            name="franchiseType"
            checked={franchiseType === "FA1"}
            onChange={() => setFranchiseType("FA1")}
          />

          <Form.Check
            type="radio"
            label="Franchise 2"
            name="franchiseType"
            checked={franchiseType === "FA2"}
            onChange={() => setFranchiseType("FA2")}
          />
        </div>

        {franchiseType && (
          <CreatableSelect
            label="Select Franchise"
            options={franchiseOptions}
            value={selectedFranchise}
            onChange={setSelectedFranchise}
            placeholder="Choose Franchise"
          />
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>

        <Button
          variant="primary"
          onClick={handleSave}
          disabled={loading}
        >
          {loading ? "Saving..." : "Save"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReassignCustomerModal;